module.exports = __webpack_public_path__ + "assets/CTranslateCircle.68e5f8847cb6695cce9a4e318cf320c0.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/CTranslateCircle.gmt
// module id = 909
// module chunks = 0